<footer class="portal-footer">
  <div class="portal-footer-inner">
    <div class="footer-brand">
      <span class="footer-dot"></span>
      <span>&copy; {{ currentYear }} <strong>BeeFund</strong> by <a href="https://limefactory.nl" target="_blank" rel="noopener noreferrer">Lime Factory</a></span>
    </div>
    <div class="footer-links">
      <a href="https://beefund.app" target="_blank" rel="noopener noreferrer">beefund.app</a>
    </div>
  </div>
</footer>
